export default __webpack_public_path__ + "static/media/C2_40_x_50_Blanc.df86b0dc.jpg";